// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const winery = defineModel({
  id: "winery",
  batchId: "future",
  name: "Winery",
  tags: ["building","winery","low-poly","age-of-mcp","future"],
  summary: "Presses and ferments grapes into wine — an amenity and trade good.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.5,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => [
      { geometry: new THREE.BoxGeometry(0.86, 0.14, 0.86), color: "#5a5a5a", position: [0, 0.07, 0] },
    ] },
    { id: "stage-1", label: "Lower", parts: () => [
      { geometry: new THREE.BoxGeometry(0.86, 0.14, 0.86), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.78, 0.3, 0.12), color: "#9a8f7e", position: [0, 0.29, -0.33] },
      { geometry: new THREE.BoxGeometry(0.12, 0.3, 0.66), color: "#9a8f7e", position: [-0.33, 0.29, 0] },
      { geometry: new THREE.BoxGeometry(0.12, 0.3, 0.66), color: "#9a8f7e", position: [0.33, 0.29, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.6, 4), color: "#6b4a26", position: [-0.42, 0.3, -0.42] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.6, 4), color: "#6b4a26", position: [0.42, 0.3, -0.42] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.6, 4), color: "#6b4a26", position: [-0.42, 0.3, 0.42] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.6, 4), color: "#6b4a26", position: [0.42, 0.3, 0.42] },
    ] },
    { id: "stage-2", label: "Upper", parts: () => [
      { geometry: new THREE.BoxGeometry(0.86, 0.14, 0.86), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.78, 0.6, 0.12), color: "#9a8f7e", position: [0, 0.44, -0.33] },
      { geometry: new THREE.BoxGeometry(0.12, 0.6, 0.66), color: "#9a8f7e", position: [-0.33, 0.44, 0] },
      { geometry: new THREE.BoxGeometry(0.12, 0.6, 0.66), color: "#9a8f7e", position: [0.33, 0.44, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.05, 4), color: "#6b4a26", position: [-0.42, 0.525, -0.42] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.05, 4), color: "#6b4a26", position: [0.42, 0.525, -0.42] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.05, 4), color: "#6b4a26", position: [-0.42, 0.525, 0.42] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.05, 4), color: "#6b4a26", position: [0.42, 0.525, 0.42] },
    ] },
    { id: "complete", label: "Complete", parts: () => [
      { geometry: new THREE.BoxGeometry(0.86, 0.14, 0.86), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.78, 0.66, 0.12), color: "#9a8f7e", position: [0, 0.47, -0.33] },
      { geometry: new THREE.BoxGeometry(0.12, 0.66, 0.66), color: "#9a8f7e", position: [-0.33, 0.47, 0] },
      { geometry: new THREE.BoxGeometry(0.12, 0.66, 0.66), color: "#9a8f7e", position: [0.33, 0.47, 0] },
      { geometry: new THREE.BoxGeometry(0.94, 0.06, 0.552178), color: "#7a4226", position: [0, 0.96, 0.225], rotation: [0.618144, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.94, 0.06, 0.552178), color: "#7a4226", position: [0, 0.96, -0.225], rotation: [-0.618144, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.98, 0.07, 0.07), color: "#4a2818", position: [0, 1.12, 0] },
      { geometry: new THREE.CylinderGeometry(0.2, 0.18, 0.2, 12), color: "#5a3a2a", position: [0.02, 0.24, 0.14] },
      { geometry: new THREE.CylinderGeometry(0.175, 0.175, 0.02, 12), color: "#5a1f3a", position: [0.02, 0.33, 0.14] },
      { geometry: new THREE.CylinderGeometry(0.15, 0.15, 0.05, 10), color: "#6e4a28", position: [0.02, 0.38, 0.14] },
      { geometry: new THREE.CylinderGeometry(0.035, 0.035, 0.4, 8), color: "#caa46a", position: [0.02, 0.58, 0.14] },
      { geometry: new THREE.CylinderGeometry(0.05, 0.05, 0.04, 8), color: "#7a5226", position: [0.02, 0.5, 0.14] },
      { geometry: new THREE.CylinderGeometry(0.05, 0.05, 0.04, 8), color: "#7a5226", position: [0.02, 0.64, 0.14] },
      { geometry: new THREE.BoxGeometry(0.05, 0.62, 0.05), color: "#6e4a28", position: [-0.22, 0.45, 0.14] },
      { geometry: new THREE.BoxGeometry(0.05, 0.62, 0.05), color: "#6e4a28", position: [0.26, 0.45, 0.14] },
      { geometry: new THREE.BoxGeometry(0.58, 0.07, 0.1), color: "#7a5226", position: [0.02, 0.74, 0.14] },
      { geometry: new THREE.BoxGeometry(0.4, 0.04, 0.04), color: "#7a5226", position: [0.08, 0.78, 0.14], rotation: [0, 0.4, 0] },
      { geometry: new THREE.CylinderGeometry(0.095, 0.085, 0.22, 10), color: "#7a5230", position: [-0.24, 0.25, -0.16], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.CylinderGeometry(0.095, 0.085, 0.22, 10), color: "#7a5230", position: [-0.24, 0.25, 0.04], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.CylinderGeometry(0.095, 0.085, 0.22, 10), color: "#7a5230", position: [-0.24, 0.44, -0.06], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.22, 0.12, 0.18), color: "#7a5226", position: [0.26, 0.21, -0.2] },
      { geometry: new THREE.SphereGeometry(0.1, 8, 6), color: "#5a1f3a", position: [0.26, 0.29, -0.2], scale: [1, 0.6, 0.8] },
    ] },
  ],
  animations: [],
});
